<app-expandable-section
  [title]="'DEAD_LETTERS.DETAIL.SECTIONS.COMPANY_INFO' | translate"
  [(expanded)]="expanded"
  (expandedChange)="expandedChange.emit($event)"
  [showChangeIndicator]="showChangeIndicator">

  @if (!expanded) {
    <div class="company-summary">
      <span class="company-name">{{ company.name }}</span>
      @if (company.email) {
        <span class="company-email">{{ company.email }}</span>
      }
    </div>
  }

  @if (expanded) {
    <div class="company-details">
      @for (entry of companyCompare | keyvalue; track entry) {
        <div class="compare-field">
          <span class="label">{{ entry.value.labelKey | translate }}</span>
          <span
            class="value"
            [class.value-changed]="entry.value.changed"
            [matTooltip]="entry.value.tooltip || null">
            {{ entry.value.value || ('DEAD_LETTERS.DETAIL.VALUES.NOT_AVAILABLE' | translate) }}
            @if (entry.value.changed) {
              <mat-icon
                class="change-icon"
                [matTooltip]="('DEAD_LETTERS.DETAIL.VALUES.PREVIOUS_VALUE' | translate) + ': ' + (entry.value.previousValue || ('DEAD_LETTERS.DETAIL.VALUES.NOT_AVAILABLE' | translate))">
                change_circle
              </mat-icon>
            }
          </span>
        </div>
      }
    </div>
  }
</app-expandable-section>
